export const scrollBarWidth = 9;
export const CommandBarHeight = 44;

export const headerHeight = 50;
export const navBarHeight = 44;
export const formTopBorderWidth = 0;
export const financePivotHeight = 44;
